import { TILE } from '../core/constants';
import type { Level } from '../core/level';
import type { AABB } from '../core/types';

export interface Camera {
  x: number;
  y: number;
}

function clamp(v: number, lo: number, hi: number): number {
  return Math.max(lo, Math.min(hi, v));
}

/** Center the camera on `target`, clamped to the level bounds so we never
 *  scroll past the edges. */
export function followCamera(
  cam: Camera,
  target: AABB,
  viewW: number,
  viewH: number,
  level: Level,
): void {
  const levelW = level.width * TILE;
  const levelH = level.height * TILE;
  const cx = target.x + target.w / 2;
  const cy = target.y + target.h / 2;
  cam.x = clamp(cx - viewW / 2, 0, Math.max(0, levelW - viewW));
  cam.y = clamp(cy - viewH / 2, 0, Math.max(0, levelH - viewH));
}
